export const leadsQueryBase = {
	_limit: '25',
	_sort: '-createdAt',
};
